import { render, staticRenderFns } from "./CrewControlsSidebar.vue?vue&type=template&id=ef083fca"
import script from "./CrewControlsSidebar.vue?vue&type=script&lang=js"
export * from "./CrewControlsSidebar.vue?vue&type=script&lang=js"
import style0 from "./CrewControlsSidebar.vue?vue&type=style&index=0&id=ef083fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports